import React from "react";
import "../../../styles/globalStyles.css";
import styles from "./Web.module.css";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Support() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);
  const [hoveredColumn, setHoveredColumn] = useState(null);

  const hoverClasses = [
    styles.hoverColumnHeading,
    styles.hoverColumn,
    styles.hoverColumnCream,
    styles.hoverColumnOrange
  ];

  const getColumnHoverClass = (index) =>
    hoveredColumn === index ? hoverClasses[index] : "";

  return (
    <section id="support" className={"light"}>
      <div className={styles.subscriptionTitle}>
        <h2>Wsparcie i utrzymanie strony</h2>
      </div>

      <div className={styles.planContainerSubscription}>
        <table className={styles.planTable}>
          <thead>
            <tr>
              <th
                className={getColumnHoverClass(0)}
                onMouseEnter={() => setHoveredColumn(0)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Pakiet
              </th>
              <th
                className={getColumnHoverClass(1)}
                onMouseEnter={() => setHoveredColumn(1)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                „Basic”
              </th>
              <th
                className={getColumnHoverClass(2)}
                onMouseEnter={() => setHoveredColumn(2)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                „Standard”
              </th>
              <th
                className={getColumnHoverClass(3)}
                onMouseEnter={() => setHoveredColumn(3)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                „Premium”
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                className={getColumnHoverClass(0)}
                onMouseEnter={() => setHoveredColumn(0)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Cena
              </th>
              <td
                className={getColumnHoverClass(1)}
                onMouseEnter={() => setHoveredColumn(1)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                100 zł/miesięcznie
              </td>
              <td
                className={getColumnHoverClass(2)}
                onMouseEnter={() => setHoveredColumn(2)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                200 zł/miesięcznie
              </td>
              <td
                className={getColumnHoverClass(3)}
                onMouseEnter={() => setHoveredColumn(3)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                400 zł/miesięcznie
              </td>
            </tr>
            <tr>
              <th
                className={getColumnHoverClass(0)}
                onMouseEnter={() => setHoveredColumn(0)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <span className={styles.headingRangePackage}>
                  W ramach pakietu
                </span>
              </th>
              <td
                className={getColumnHoverClass(1)}
                onMouseEnter={() => setHoveredColumn(1)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <ul>
                  <li>monitorowanie działania strony</li>
                  <li>regularna kopia bezpieczeństwa</li>
                  <li>aktualizacja techniczna</li>
                  <li>przeprowadzenie drobnych poprawek</li>
                </ul>
                <p className={styles.infoOnImplementation}>
                  <strong>
                    Podstawowa opieka techniczna do 1 godziny pracy miesięcznie
                    lub 1 większa interwencja.
                  </strong>
                </p>
              </td>
              <td
                className={getColumnHoverClass(2)}
                onMouseEnter={() => setHoveredColumn(2)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <ul>
                  <li>wszystko co znajduje się w pakiecie „Basic”</li>
                  <li>aktualizacja treści</li>
                  <li>pomoc techniczna</li>
                  <li>podstawowe działania optymalizacyjne</li>
                </ul>
                <p className={styles.infoOnImplementation}>
                  <strong>
                    Podstawowa opieka techniczna do 2 godzin pracy miesięcznie.
                  </strong>
                </p>
              </td>
              <td
                className={getColumnHoverClass(3)}
                onMouseEnter={() => setHoveredColumn(3)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <ul>
                  <li>wszystko co znajduje się w pakiecie „Standard”</li>
                  <li>rozbudowa strony o nowe elementy i podstrony</li>
                  <li>konsultacje dotyczące rozwoju strony</li>
                  <li>priorytetowa obsługa</li>
                </ul>
                <p className={styles.infoOnImplementation}>
                  <strong>
                    Opieka techniczna do 5 godzin pracy miesięcznie.
                  </strong>
                </p>
              </td>
            </tr>
            <tr>
              <td
                className={getColumnHoverClass(0)}
                onMouseEnter={() => setHoveredColumn(0)}
                onMouseLeave={() => setHoveredColumn(null)}
              ></td>
              <td
                className={getColumnHoverClass(1)}
                onMouseEnter={() => setHoveredColumn(1)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <Link to="/#contact" className={styles.buyButton}>
                  Zakup abonament
                </Link>
              </td>
              <td
                className={getColumnHoverClass(2)}
                onMouseEnter={() => setHoveredColumn(2)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <Link to="/#contact" className={styles.buyButton}>
                  Zakup abonament
                </Link>
              </td>
              <td
                className={getColumnHoverClass(3)}
                onMouseEnter={() => setHoveredColumn(3)}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <Link to="/#contact" className={styles.buyButton}>
                  Zakup abonament
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* ---------------------------------------------------------- */}

      <div className={styles.subscriptionCard}>
        <div className={styles.planCardItemGreen}>
          <div className={styles.planCardHeading}>
            <h2>„Start”</h2>
          </div>
          <div className={styles.planCardPrice}>
            <p>100 zł/miesięcznie</p>
          </div>
          <div className={styles.planCardRange}>
            <ul className={styles.rangeOfPackage}>
              <li>monitorowanie działania strony</li>
              <li>regularna kopia bezpieczeństwa</li>
              <li>aktualizacja techniczna</li>
              <li>przeprowadzenie drobnych poprawek</li>
            </ul>
            <p className={styles.infoOnImplementationMobile}>
              <strong>
                Podstawowa opieka techniczna do 1 godziny pracy miesięcznie lub
                1 większa interwencja.
              </strong>
            </p>
          </div>
          <div className={styles.buttonContainerGreen}>
            <Link to="/#contact" className={styles.assessmentButton}>
              Zakup abonament
            </Link>
          </div>
        </div>
        <div className={styles.planCardItemCream}>
          <div className={styles.planCardHeading}>
            <h2>„Standard”</h2>
          </div>
          <div className={styles.planCardPrice}>
            <p>200 zł/miesięcznie</p>
          </div>
          <div className={styles.planCardRange}>
            <ul className={styles.rangeOfPackage}>
              <li>wszystko co znajduje się w pakiecie „Start”</li>
              <li>aktualizacja treści</li>
              <li>pomoc technicza</li>
              <li>podstawowe działania optymalizacyjne</li>
            </ul>
            <p className={styles.infoOnImplementationMobile}>
              <strong>
                Podstawowa opieka techniczna do 2 godzin pracy miesięcznie.
              </strong>
            </p>
          </div>
          <div className={styles.buttonContainerCream}>
            <Link to="/#contact" className={styles.assessmentButton}>
              Zakup abonament
            </Link>
          </div>
        </div>
        <div className={styles.planCardItemOrange}>
          <div className={styles.planCardHeading}>
            <h2>„Prmium”</h2>
          </div>
          <div className={styles.planCardPrice}>
            <p>400 zł/miesięcznie</p>
          </div>
          <div className={styles.planCardRange}>
            <ul className={styles.rangeOfPackage}>
              <li>wszystko co znajduje się w pakiecie „Standard”</li>
              <li>rozbudowa strony o nowe elementy i podstrony</li>
              <li>konsultacje dotyczące rozwoju strony</li>
              <li>priorytetowa obsługa</li>
            </ul>
            <p className={styles.infoOnImplementationMobile}>
              <strong>Opieka techniczna do 5 godzin pracy miesięcznie.</strong>
            </p>
          </div>
          <div className={styles.buttonContainerOrange}>
            <Link to="/#contact" className={styles.assessmentButton}>
              Zakup abonament
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
